// 9fbef606107a605d69c0edbcd8029e5de
import { css } from 'styled-components';

const drawerModalStyles = css`
  .TCPModal__Content {
    width: 481px;
    height: auto;
    padding: 12px 16px;
    gap: 10px;
  }
  .Modal_Heading {
    border-bottom: none !important;
    padding-top: 5px;
    color: #1a1a1a;
    font-family: Nunito;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    display: flex;
    justify-content: center;
    height: auto;
    margin-bottom: 0px !important;

    @media ${(props) => props.theme.mediaQuery.medium} {
      display: flex !important;
      justify-content: center;
      height: auto;
    }

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 52px;
      margin: auto;
      z-index: -1;
      background-color: #f4f4f4;
      bottom: 12px;
      left: -17px;
      padding-right: 17px;

      @media ${(props) => props.theme.mediaQuery.medium} {
        left: -17px;
        padding-right: 17px;
      }

      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        height: 48px;
        width: 100%;
      }
    }
  }

  .Modal_Header {
    padding-top: 5px;
    height: 52px;
    width: 100%;
  }

  .horizontal-line {
    margin-top: 24px;
    margin-bottom: 24px;
    height: 1px;
    background: #ddd;
    width: auto;
    border: none;
  }

  .count-sort-products {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }

  .products-count {
    color: #595959;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
    letter-spacing: 0.5px;
    text-transform: capitalize;
  }

  .sort-wrapper {
    display: flex;
    justify-content: flex-end !important;
    gap: 8px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: flex !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
  }

  .one-hr-filter-and-sort-selector-wrapper {
    margin-bottom: 0;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block;
    }
  }

  .custom-select-title {
    font-size: 14px !important; /* your desired size */
    position: relative;
    left: 0;
    top: 0;
    color: #000;
    font-family: Nunito, sans-serif;
    font-weight: 500;
    line-height: 150%;
    letter-spacing: 0.5px;
    text-transform: capitalize;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block !important;
    }
  }

  .custom-sort-dropdown {
    border-bottom: none !important;
    padding-bottom: 0 !important;
  }

  .sort-item-selected {
    color: #000;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
    letter-spacing: 0.5px;
    text-transform: capitalize;
    text-overflow: unset !important;
  }

  .similar-products-container {
    margin-top: 14px;
    position: absolute;
    flex-direction: column;
    width: 100%;
    padding-right: 16px;
    padding-left: 16px;
    box-sizing: border-box;
    gap: 16px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: 12px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: -17px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-left: -17px;
      margin-right: 32px;
    }
  }

  .product-details-pdp {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    gap: 16px;
    height: 176px;
    width: auto;
    box-sizing: border-box; /* optional: helps padding stay within width */

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 146px;
    }
  }

  .product-image-pdp {
    width: 141px;
    height: 176px;

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 117px;
      height: 146px;
    }
  }

  .details {
    display: flex;
    flex-direction: column;
    width: 292px;
    height: auto; /* hug content */
    gap: 20px; /* optional: spacing between lines */
    font-family: Nunito;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 263px;
    }
  }

  .details p:first-child {
    font-family: Nunito;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%; /* 21px */
    letter-spacing: 0;
    width: auto;
    height: auto;
    margin: 0;
    color: #1a1a1a;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 12px;
    }
  }

  .pdp-details {
    display: flex; /* required for gap to work */
    flex-direction: column; /* vertical stacking */
    gap: 12px;
  }

  .pdp-line {
    display: flex;
    flex-direction: row;
    gap: 8px; /* horizontal space between label and value */
    height: auto;
    width: auto;
  }

  .pdp-line .label {
    height: 21px;
    font-family: Nunito;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%; /* or line-height: 21px; */
    letter-spacing: 0.5px;
    white-space: nowrap;
    color: #1a1a1a;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 12px;
    }
  }

  .pdp-line .value {
    width: auto;
    height: auto;
    font-family: Nunito;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%; /* or 21px */
    letter-spacing: 0.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #595959;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 12px;
    }
  }

  .similar-products-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 28px 16px;
    margin-bottom: 24px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      gap: 28px 16px;
    }
  }

  .product-tile {
    width: calc(50% - 8px);
  }

  .product-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    height: 100%;
    gap: 12px;
    width: 100%;
  }

  .product-image-wrapper {
    cursor: pointer;
    background: none;
    border: none;
    width: 100%;
    padding-right: 0;
    padding-left: 0;
    height: 100%;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 100%;
    }
  }

  .product-image {
    width: 100%;
    background-color: #f0f0f0;
    height: 100%;
    object-fit: cover;
  }

  .product-details {
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: row; /* horizontal flow */
    justify-content: space-between; /* space between children */

    .atb-icon-image {
      width: 42px;
      height: 42px;
    }

    .similar-modal-product-price {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;

      .strike-price-and-merchant-tag-wrapper {
        align-items: center;
      }

      .strike-price {
        font-size: 12px;
      }
    }

    .offer-price-tag {
      font-family: Nunito;
      font-weight: 800;
      font-size: 16px;
      color: #000;
      line-height: 150%; /* equals 24px if 16px * 1.5 */
      letter-spacing: 0;
      vertical-align: middle;
      width: 53px;
      height: 24px;
      display: flex; /* to help vertical align middle */
      align-items: flex-start; /* vertical centering inside box */
    }

    .merchant-tag {
      color: #000;
      font-family: Nunito;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 21px */
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: 12px;
      }
    }

    .add-to-bag-icon {
      cursor: pointer;
      background: none;
      border: none;
      padding: 0;
    }
  }
`;

export default drawerModalStyles;
